export default {
      id: "icon-licorne-usage",
      viewBox: "0 0 165.6 112.7",
      url: __webpack_public_path__ + "icons.svg#icon-licorne",
      toString: function () {
        return this.url;
      }
    }